import { render } from "./QutoesDetailsModal.vue?vue&type=template&id=f9b46d2e"
import script from "./QutoesDetailsModal.vue?vue&type=script&lang=js"
export * from "./QutoesDetailsModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__